import { createSlice } from '@reduxjs/toolkit';

export type IData = {
  org_id: string;
  org_name: string;
  count: string;
  prefix: string;
};

type RequestCommandState = {
  loading: boolean;
  data: IData[];
  active?: IData;
};

const initialState: RequestCommandState = {
  loading: false,
  data: [],
};

export const orgListLawSuitSlice = createSlice({
  name: 'orgListLawSuit',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setActive: (state, action) => {
      state.active = action.payload;
    },
  },
});

export default orgListLawSuitSlice.reducer;
